module.exports = {
	"authors": {
		"ajsantander": {
			"name": "Alejandro Santander",
			"email": "palebluedot@gmail.com",
			"website": "https://github.com/ajsantander",
			"donate": "0x31a3801499618d3c4b0225b9e06e228d4795b55d"
		},
		"raz0r": {
			"name": "Arseny Reutov",
			"email": "me@raz0r.name",
			"website": "https://raz0r.name"
		},
		"beched": {
			"name": "Omar Ganiev",
			"email": "beched@deteact.com",
			"website": "https://defisecurity.io/"
		}
	}
};


//////////////////
// WEBPACK FOOTER
// ./gamedata/authors.json
// module id = 1806
// module chunks = 0